"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactHookForm = require("react-hook-form");
var _reactTracking = require("react-tracking");
var _iconAlert = _interopRequireDefault(require("../../icons/icon-alert.svg"));
var _iconLocation = _interopRequireDefault(require("../../icons/icon-location.svg"));
const StyledErrorMessage = _styled.default.div(_ref => {
  let {
    errorMessageShown,
    theme
  } = _ref;
  return {
    display: errorMessageShown ? 'flex' : 'none',
    alignItems: 'center',
    color: theme === null || theme === void 0 ? void 0 : theme.colors.red,
    fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.xxxSmall,
    marginTop: '7px',
    '> img': {
      margin: '0px 8px'
    }
  };
});
const StyledSelect = _styled.default.select({
  cursor: 'pointer',
  height: '100%',
  opacity: 0,
  position: 'absolute',
  width: '100%',
  '&:focus + label': {
    outline: '1px auto',
    outlineColor: '-webkit-focus-ring-color',
    outlineOffset: '1px'
  },
  '&:hover + label': {
    textDecoration: 'none'
  }
});
const LocationContainer = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    color: theme.colors.textPrimary,
    fontSize: theme.fontSizes.small,
    display: 'flex',
    width: 'max-content',
    '> img': {
      marginTop: '-2px'
    }
  };
});
const SelectContainer = _styled.default.div({
  alignItems: 'center',
  display: 'flex',
  position: 'relative'
});
const StyledLabel = _styled.default.label(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    fontSize: theme.fontSizes.xxSmall,
    margin: '0px 10px',
    textDecoration: 'underline'
  };
});

/**
 * Similar to Select.tsx. This component creates a clickable "link" that activates a hidden <select> element (opacity 0).
 */
const LocationSelect = _ref4 => {
  let {
    control,
    disabled = false,
    editText,
    errorMessage,
    id,
    isTracking = false,
    optionalText,
    options,
    register
  } = _ref4;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const newOption = (0, _reactHookForm.useWatch)({
    control,
    name: id
  });
  const oldOption = (0, _react.useRef)(newOption);
  const handleTracking = () => {
    if (isTracking) {
      trackEvent({
        event_name: 'option-selected',
        event_type: 'click',
        newOption,
        oldOption: oldOption.current
      });
      oldOption.current = newOption;
    }
  };
  (0, _react.useEffect)(() => {
    handleTracking();
  }, [newOption]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    field
  } = (0, _reactHookForm.useController)({
    name: 'country',
    control
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(LocationContainer, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "location-icon",
    src: _iconLocation.default
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      margin: '0px 4px'
    }
  }, options[field === null || field === void 0 ? void 0 : field.value] || 'none'), /*#__PURE__*/_react.default.createElement(SelectContainer, null, /*#__PURE__*/_react.default.createElement(StyledSelect, Object.assign({}, register(id), {
    "aria-label": "country-select",
    disabled: disabled,
    id: "country"
  }), Array.isArray(options) ? options.map(option => /*#__PURE__*/_react.default.createElement("option", {
    key: `${id}-${option}`,
    value: option
  }, option)) : Object.keys(options).map(key => /*#__PURE__*/_react.default.createElement("option", {
    disabled: key === 'noValue',
    key: `${id}-${key}`,
    value: key === 'noValue' ? '' : key
  }, options[key]))), /*#__PURE__*/_react.default.createElement(StyledLabel, {
    htmlFor: "country"
  }, editText)), optionalText), errorMessage && /*#__PURE__*/_react.default.createElement(StyledErrorMessage, {
    errorMessageShown: true,
    id: `${id}-error`
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "alert",
    src: _iconAlert.default
  }), /*#__PURE__*/_react.default.createElement("span", null, errorMessage)));
};
LocationSelect.displayName = 'LocationSelect';
var _default = exports.default = LocationSelect;